<template>
    <div v-if="token" class="hide-overflow"
         style="position: relative;">
        <v-app-bar v-if="token"
                   color="#0d47a1"
                   :elevate-on-scroll=true
                   dark
                   fixed>
            <v-btn icon @click="goto(back_item.back_route)">
                <v-icon v-if="back_item.back_route">mdi-arrow-left</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>{{ back_item.title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

            <!--            <v-toolbar-items class="hidden-sm-and-down" v-for="(item,key) in items">-->
            <!--                <v-btn v-if="ntCode && key === 0" text @click="goto('project')">{{ ntCode }}</v-btn>-->
            <!--                <v-btn text @click="goto(item.url)">{{ item.title }}</v-btn>-->
            <!--            </v-toolbar-items>-->
        </v-app-bar>

        <v-navigation-drawer temporary
                             v-model="drawer"
                             fixed
                             id="drawer"
                             right
                             width="270px">
            <v-flex xs12 sm12 md12 style="text-align: center" class="mt-12">
                <img src="../assets/img/logo/350x350.png" style="width: 80px" alt=""/>
            </v-flex>
            <div class="flex xs12 md12 sm12 mb-3">
                <h2 class="mt-3 text-center headline">ระบบพัสดุ</h2>
            </div>
            <div class="flex xs12 md12 sm12 mb-3">
                <h2 class="mt-3 text-center body-2" style="color: #90A4AE">Login : {{ username }}</h2>
            </div>
            <div class="flex xs12 md12 sm12 mb-3 text-center" v-if="ntCode">
                <v-btn outlined rounded @click="goto('project')" color="blue darken-4">
                    <h2 class="text-center body-2" style="color: #90A4AE">
                        {{ ntCode }}
                        <b>
                            <v-icon color="#000">mdi-format-list-bulleted-square</v-icon>
                        </b>
                    </h2>
                </v-btn>
            </div>
            <v-divider></v-divider>
            <v-list>
                <v-list-item v-for="item in items"
                             :key="item.title"
                             @click="goto(item.url)"
                             link>
                    <v-list-item-icon>
                        <v-icon v-if="item.url == 'logout'" color="red">{{ item.icon }}</v-icon>
                        <v-icon v-else>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title v-if="item.url == 'logout'" style="color: #F44336;">
                            <strong>{{ item.title }}</strong>
                        </v-list-item-title>
                        <v-list-item-title v-else>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
import EventBus from '@/EventBus'

export default {
    name: 'AppBar',
    data() {
        return {
            drawer: null,
            items: [],
            back_item: {
                title: '', back_route: '', params: {}
            },
            username: this.getLocalItem().user_id,
            ntCode: '',
        }
    },
    props: {
        token: String,
        nt_code: String,
        titleName: String,
        back_route: String
    },
    watch: {
        token() {
            this.authMenu()
        },
        user() {
            this.authMenu()
        },
        nt_code() {
            this.ntCode = this.nt_code
            this.authMenu()
        },
        titleName() {
            this.back_item.title = this.titleName
        }
    },
    mounted() {
        this.authMenu()

        EventBus.$on('set_navigation', views_title => {
            this.back_item.title = views_title.title
            this.back_item.back_route = views_title.back_route
            this.back_item.params = views_title.params
        })

    },
    methods: {
        authMenu() {
            let localItem = this.getLocalItem()
            if (localItem.nt_code) {
                this.ntCode = localItem.nt_code
            }
            if (this.nt_code || localItem.nt_code) {
                if (localItem.role === '1' || localItem.role === 1) {
                    this.items = [
                        {title: 'บันทึกรับพัสดุ', icon: 'mdi-package-variant-closed', url: 'waiting-parcel'},
                        {title: 'บันทึกจ่ายพัสดุ', icon: 'mdi-account-arrow-right-outline', url: 'search-parcel'},
                        {title: 'บันทึกรับพัสดุนอกเวลา', icon: 'mdi-email', url: 'ot-parcel-emp'},
                        {title: 'รายการพัสดุนอกเวลา', icon: 'mdi-playlist-check', url: 'ot-list-submit'},
                        {title: 'พิมพ์พัสดุนอกเวลา', icon: 'mdi-chart-box-outline', url: 'ot-parcel-report'},
                        {title: 'เพิ่มพัสดุเข้า Box24', icon: 'mdi-briefcase-plus-outline', url: 'location-box24'},
                        {title: 'สถานะพัสดุนอกเวลา', icon: 'mdi-list-status', url: 'ot-parcel-status'},
                        {title: 'แก้ไขสถานะ', icon: 'mdi-clipboard-edit', url: 'status-change'},
                        {title: 'แก้ไขข้อมูลลูกค้า', icon: 'mdi-account-edit', url: 'edit-customer'},
                        {title: 'คู่มือพัสดุ', icon: 'mdi-file-chart', url: 'parcel-manual'},
                        {title: 'ออกจากระบบ', icon: 'mdi-exit-to-app', url: 'logout'}
                    ]
                } else {
                    this.items = [
                        {title: 'บันทึกรับพัสดุ', icon: 'mdi-package-variant-closed', url: 'waiting-parcel'},
                        {title: 'บันทึกจ่ายพัสดุ', icon: 'mdi-account-arrow-right-outline', url: 'search-parcel'},
                        {title: 'บันทึกรับพัสดุนอกเวลา', icon: 'mdi-email', url: 'ot-parcel-emp'},
                        {title: 'รายการพัสดุนอกเวลา', icon: 'mdi-playlist-check', url: 'ot-list-submit'},
                        {title: 'พิมพ์พัสดุนอกเวลา', icon: 'mdi-chart-box-outline', url: 'ot-parcel-report'},
                        {title: 'เพิ่มพัสดุเข้า Box24', icon: 'mdi-briefcase-plus-outline', url: 'location-box24'},
                        {title: 'สถานะพัสดุนอกเวลา', icon: 'mdi-list-status', url: 'ot-parcel-status'},
                        {title: 'แก้ไขข้อมูลลูกค้า', icon: 'mdi-account-edit', url: 'edit-customer'},
                        {title: 'คู่มือพัสดุ', icon: 'mdi-file-chart', url: 'parcel-manual'},
                        {title: 'ออกจากระบบ', icon: 'mdi-exit-to-app', url: 'logout'}
                    ]
                }
            } else {
                this.items = [
                    {title: 'ออกจากระบบ', icon: 'mdi-exit-to-app', url: 'logout'}
                ]
            }

        },
        goto(route_name, params) {
            if (route_name == 'logout') {
                EventBus.$emit('resetToken')
                return this.logout()
            } else {
                if (params) {
                    EventBus.$emit(params.eventbus_call, params.params)
                }
                return this.$router.push({name: route_name})
            }
        }
    }
}
</script>

<style scoped>

</style>
